<form
  class="auth-form"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  novalidate
>
  <div class="auth-form__grid">
    <app-input
      id="auth-register-name"
      label="Nombre"
      type="text"
      formControlName="name"
    />
    <app-input
      id="auth-register-surnames"
      label="Apellidos"
      type="text"
      formControlName="surnames"
    />
  </div>

  <app-input
    id="auth-register-email"
    label="Correo electrónico"
    type="email"
    placeholder="tu@correo.com"
    formControlName="email"
  />

  <div class="auth-form__password-group">
    <app-input
      id="auth-register-password"
      label="Contraseña"
      type="password"
      placeholder="••••••••"
      formControlName="password"
    />
    <ul class="auth-form__requirements" aria-label="Requisitos de la contraseña">
      @for (req of requirements; track req.key) {
        <li
          class="auth-form__requirement"
          [class.auth-form__requirement--ok]="requirementStatus()[req.key]"
        >
          <span class="auth-form__requirement-icon" aria-hidden="true">
            <app-icon
              [icon]="requirementStatus()[req.key] ? checkIcon : circleIcon"
              [size]="14"
              color="currentColor"
            />
          </span>
          {{ req.label }}
        </li>
      }
    </ul>
  </div>

  <app-input
    id="auth-register-password-confirmation"
    label="Confirmar contraseña"
    type="password"
    placeholder="••••••••"
    formControlName="password_confirmation"
  />

  <div class="auth-form__newsletter">
    <app-checkbox
      [id]="newsletterId"
      label="Quiero recibir novedades y ofertas por correo"
      [checked]="newsletterChecked()"
      (checkedChange)="onNewsletterChange($event)"
    />
    <!-- B8 (W4): mismo microcopy que el formulario; la política se abre en otra pestaña (N6). -->
    <app-newsletter-consent class="auth-form__consent" [external]="true" />
  </div>

  @if (errorMessage()) {
    <p class="auth-form__error" role="alert">
      {{ errorMessage() }}
      @if (errorShowsLoginLink()) {
        <button type="button" class="auth-form__inline-link" (click)="switchToLogin()">
          Iniciar sesión
        </button>
      }
      @if (errorShowsRecoverLink()) {
        <button type="button" class="auth-form__inline-link" (click)="switchToForgotPassword()">
          {{ recoverPasswordLink }}
        </button>
      }
    </p>
  }

  <app-button
    variant="primary"
    size="lg"
    type="submit"
    [loading]="loading()"
    [disabled]="loading()"
  >
    Crear cuenta
  </app-button>

  <div class="auth-form__links">
    <button type="button" class="auth-form__link" (click)="switchToLogin()">
      ¿Ya tienes cuenta? Iniciar sesión
    </button>
  </div>
</form>
